<ng-container *transloco="let t">
  @if (picture) {
    <pxc-studio [config]="studioConfig" [imageSrc]="picture.source" [topBarConfig]="topBarConfig" />
    <pxc-compliance-logo class="absolute right-4 bottom-4 h-5" [targetModuleId]="targetModuleId" />
  }

  @let woundsizeResultItems = woundsizeResultItems$ | async;
  <div class="absolute right-0 top-16">
    <div class="flex flex-col gap-4 p-4 pb-16" id="woundtrackResults">
      @if (woundsizeResultItems?.length) {
        <div
          appearance="outline"
          class="max-w-sm p-0! shadow-xl! animate-in fade-in slide-in-from-right-8"
          tuiCardLarge="">
          <pxc-module-result [items]="woundsizeResultItems" [title]="t('Dimensions')" />
        </div>
      }
    </div>
  </div>
</ng-container>

<pxc-woundsize-tutorial />
